import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  basePath: '/api/auth',
  // Passkeys: platform/passkey.ts (erst bei Bedarf geladen)
  plugins: [magicLinkClient()],
});
